var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1373_28998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#2A2A2A",
    stroke: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7393 9.51277L10.9778 15.7548C10.803 15.9136 10.5716 16.0014 10.3316 16C10.0952 16.0009 9.86761 15.9129 9.697 15.7548L6.31623 12.6338C6.22246 12.5547 6.1462 12.4582 6.09203 12.35C6.03787 12.2417 6.00691 12.1241 6.00103 12.004C5.99515 11.8839 6.01446 11.7639 6.05781 11.6512C6.10116 11.5385 6.16764 11.4355 6.25327 11.3483C6.3389 11.261 6.4419 11.1914 6.55608 11.1436C6.67027 11.0958 6.79328 11.0708 6.91772 11.0701C7.04216 11.0694 7.16546 11.0931 7.28021 11.1396C7.39496 11.1861 7.49879 11.2545 7.58546 11.3408L10.3316 13.871L16.4701 8.21978C16.6496 8.06851 16.8826 7.99012 17.1205 8.001C17.3585 8.01187 17.5828 8.11117 17.7467 8.27813C17.9106 8.4451 18.0014 8.6668 18 8.89689C17.9986 9.12699 17.9052 9.34766 17.7393 9.51277Z",
    fill: "#D8F6D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1373_28998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4e9d74d45f32e8de24910310d6cda42f.svg";
export { ForwardRef as ReactComponent };